import { useState, useEffect } from "react";
import { useObserver } from "mobx-react";
import { MdCloudUpload, MdOutlineAutoFixHigh } from "react-icons/md";
import { useStores } from "../../../store";

import { pdfjs } from "react-pdf";
import Loader from "../../reusble_components/loader";
import { uploadFileToAzure } from "../../../services/azure";

export default function ResumeUploader() {
  const [file, setFile] = useState(null);
  const { RecuiterStore, PopupStore, UserStore } = useStores();
  const [loader, setLoader] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  useEffect(() => {
    // Clear the description when the component unmounts
    return () => {
      RecuiterStore.setGeneratedJD("");
    };
  }, []);

  const fetchData = async (pdfFile) => {
    try {
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = async (event) => {
          try {
            const pdfData = new Uint8Array(event.target.result);
            const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
            let fullText = "";

            for (let i = 1; i <= pdf.numPages; i++) {
              const page = await pdf.getPage(i);
              const content = await page.getTextContent();
              const pageText = content.items.map((item) => item.str).join("\n");
              fullText += pageText + "\n";
            }

            console.log(fullText);
            resolve(fullText);
          } catch (error) {
            alert("Error processing PDF file.");
            console.error("Error parsing PDF:", error);
            reject(error);
          }
        };

        reader.onerror = (error) => {
          alert("Error reading the file.");
          reject(error);
        };

        reader.readAsArrayBuffer(pdfFile);
      });
    } catch (error) {
      alert(
        "The format of the file is not supported. Please upload a valid PDF file."
      );
      console.error("Error reading PDF file", error);
    }
  };

  const uploadFileToCloud = async (file) => {
    const timestamp = Date.now().toString();
    const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
    const filenames = randomNumber + timestamp + file.name;

    const fileUploaded = await uploadFileToAzure(filenames, file, {
      action: "resume",
    });

    return fileUploaded.url;
  };

  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile && uploadedFile.type === "application/pdf") {
      setFile(uploadedFile);
      setFileToUpload(event);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      const content = await fetchData(file);
      const url = await uploadFileToCloud(file);
      const body = {
        content: content,
        jd: RecuiterStore.generatedJD,
        resume: url,
        userId: JSON.parse(localStorage.getItem("user"))._id,
      };

      const response = await UserStore.fetchResumeReport(body);
      setLoader(false);

      if (
        (response && response === 400) ||
        (response && response === 401) ||
        response === 500
      ) {
        if (response.body.message.includes("credits")) {
          PopupStore.setGetMoreCredits(true);
        }
      }
    } catch (error) {
      setLoader(false);
    }
  };

  return useObserver(() => (
    <form
      className="relative w-full  flex flex-col items-center justify-center space-y-4 px-4 md:px-10 py-4"
      onSubmit={handleSubmit}
    >
      <Loader loader={loader} />
      <div className="flex justify-between w-full items-center ">
        <h1 className="y text-2xl font-bold md:px-4 ">Create New</h1>

        <button
          className={`px-8 py-2 rounded-lg transition-all duration-200 ${
            RecuiterStore.generatedJD.trim() !== ""
              ? "bg-orange-500 hover:bg-orange-600 text-white"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
          type="submit"
          disabled={RecuiterStore.generatedJD.trim() === ""}
        >
          Sort now
        </button>
      </div>
      <div className="flex flex-col md:flex-row items-center relative md:items-start space-y-4 md:space-y-0 md:space-x-4  w-full  mx-auto">
        {/* Upload Resume Box */}
        <label className="w-full md:w-64 h-40 border-2 border-dashed border-gray-300 rounded-md flex flex-col items-center justify-center cursor-pointer hover:border-gray-500 transition">
          <input
            type="file"
            accept="application/pdf"
            required
            className="opacity-0 absolute bottom-0"
            onChange={handleFileChange}
          />
          <MdCloudUpload size={32} className="text-gray-500" />
          <p className="mt-2 text-gray-600 text-sm text-center">
            Upload your Resume
          </p>
          {file && (
            <p className="mt-1 text-xs text-green-500 text-center">
              {file.name}
            </p>
          )}
        </label>

        {/* Description Box */}
        <span className="w-full h-40  relative border overflow-hidden border-gray-300 rounded-md">
          <textarea
            className="w-[88%] relative z-0  h-full   p-2 outline-none resize-none text-gray-700"
            style={{
              scrollbarWidth: "none",
            }}
            placeholder="Add Description......"
            required
            value={RecuiterStore.generatedJD}
            onChange={(e) => RecuiterStore.setGeneratedJD(e.target.value)}
          ></textarea>
          <p
            className=" text-orange-500 flex items-center absolute top-2 right-2 gap-2 text-sm border border-orange-500 px-2 py-1 rounded-md hover:bg-orange-100 transition z-40 cursor-pointer"
            onClick={() => {
              RecuiterStore.ClearGenerateParams();
              PopupStore.setGenerate(true);
            }}
          >
            <MdOutlineAutoFixHigh />
            Auto generate
          </p>
        </span>

        {/* Auto Generate Button */}

        {/* Sort Now Button */}
      </div>
    </form>
  ));
}
